import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";

const productCards = [
  // {
  //   id: 1,
  //   image: "/websiteAssets/ApnaCard1.jpeg",
  //   title: "Personalized Branding",
  //   desc: "Incorporate company logos, colors, and designs unique to the user or business. Custom designs for specific industries, such as health care, education, or transportation.",
  // },
  // {
  //   id: 2,
  //   image: "/websiteAssets/ApnaCard2.jpeg",
  //   title: "Metal Cards",
  //   desc: "Golden, Silver, and Black premium Metal Apna Cards enhance your brand's appeal with durability, luxury, and advanced NFC for secure, efficient data sharing.",
  // },
  // {
  //   id: 3,
  //   image: "/websiteAssets/ApnaCard1.jpeg",
  //   title: "Wooden Cards",
  //   desc: "Wooden Apna Cards blend eco-friendliness, elegance, and NFC technology, offering sustainable functionality with a unique touch.",
  // },
  {
    id: 4,
    image: "/websiteAssets/ApnaCard1.jpeg",
    title: "Digital Cards",
    desc: "A simple NFC plastic card combines the basic functionality of a plastic card with the advanced technology of Near Field Communication (NFC).",
  },
  // {
  //   id: 5,
  //   image: "/websiteAssets/ApnaCard1.jpeg",
  //   title: "Premium Metal NFC-Enabled QR Keychain",
  //   desc: "Sleek, durable, and modern. Share contacts instantly with NFC or via the integrated QR code for effortless networking.",
  // },
  // {
  //   id: 6,
  //   image: "/websiteAssets/ApnaCard2.jpeg",
  //   title: "Handmade Leather (Iphone Cases)",
  //   desc: "Handmade iPhone cover is a wonderful way to express creativity and produce a unique, personalized accessory. It is a great gift for anyone who loves to stand out.",
  // },
];

const ProductShowcaseSection = () => {
  return (
    <Box
      component="section"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: { xs: 6, md: 8 },
        px: { xs: 2, md: 12.5 },
        bgcolor: "background.default",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 3.125,
          width: "100%",
          bgcolor: "background.default",
        }}
      >
        <Typography
          variant="h1"
          color="primary"
          sx={{
            fontFamily: "'Jost-Bold', Montserrat",
            fontWeight: 700,
            fontSize: { xs: "36px", sm: "44px", md: "64px" },
            letterSpacing: { xs: "-2px", md: "-3.84px" },
            lineHeight: { xs: "44px", md: "50px" },
            textAlign: "center",
          }}
        >
          OUR PRODUCTS
        </Typography>

        <Typography
          variant="body1"
          color="common.black"
          align="center"
          sx={{
            fontFamily: "'Poppins-Light', Montserrat",
            fontWeight: 300,
            fontSize: { xs: 14, sm: 16, md: 20 },
            letterSpacing: "-0.32px",
            lineHeight: 1.7,
            maxWidth: "1240px",
          }}
        >
          Our mission is to empower individuals by providing a secure platform
          to manage personal records and share profiles effortlessly with a
          single tap. We are committed to enhancing connectivity and simplifying
          access to essential information, making everyday interactions seamless
          and efficient.
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          gap: { xs: 6, md: 10 },
          py: { xs: 4, md: 6.25 },
          bgcolor: "background.default",
        }}
      >
        <Grid
          container
          spacing={{ xs: 4, md: 8, lg: 10 }}
          justifyContent="center"
        >
          {productCards.map((card) => (
            <Grid item xs={12} md={6} key={card.id}>
              <Card
                sx={{
                  bgcolor: "primary.main",
                  borderRadius: "20px",
                  height: { xs: "auto", md: "580px", lg: "646px" },
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: { xs: 2.5, md: 3.125 },
                    p: { xs: 3, md: 3.125 },
                    height: "100%",
                  }}
                >
                  <CardMedia
                    component="img"
                    image={card.image}
                    alt="Product image"
                    sx={{
                      height: { xs: 220, sm: 260, md: 320, lg: 350 },
                      width: "100%",
                      objectFit: "cover",
                      borderRadius: { xs: "16px", md: "18px" },
                    }}
                  />

                  <Divider
                    sx={{
                      bgcolor: "common.white",
                      height: "2px",
                      width: "100%",
                    }}
                  />

                  <CardContent
                    sx={{
                      p: 0,
                      position: "relative",
                      width: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <Typography
                        variant="h2"
                        color="common.white"
                        sx={{
                          fontFamily: "'Jost-ExtraBold', Montserrat",
                          fontWeight: 800,
                          fontSize: { xs: 26, sm: 32, md: 36, lg: 40 },
                        }}
                      >
                        {card.title}
                      </Typography>
                    </Box>

                    <Typography
                      variant="body2"
                      color="secondary.light"
                      sx={{
                        fontFamily: "'Satoshi-Medium', Montserrat",
                        fontWeight: 500,
                        fontSize: { xs: 14, sm: 15, md: 18, lg: 20 },
                        lineHeight: { xs: 1.7, md: 1.6 },
                        mt: 2,
                      }}
                    >
                      {card.desc}
                    </Typography>
                  </CardContent>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default ProductShowcaseSection;
